import { put, call } from "redux-saga/effects";
import { toastr } from "react-redux-toastr";
import Axios from "../../utils/axios";
import {
  submitPlayerPurchaseStripeError,
  submitPlayerPurchaseStripeDone
} from "../../state/purchase/actions";
import { showErrorSnackbar } from "../../utils/util";
import {
  EVENTS,
  PURCHASE,
  SOMETHING_WENT_WRONG_MESSAGE
} from "../../constants";
import { GET_PAYMENT_INTENT_URL_STRIPE } from "../../state/purchase/constants";

function* submitPurchaseStripe({ params }) {
  const { loadingState } = params;
  try {
    const {
      productSummary,
      client,
      eventId,
      history,
      location,
      shortName,
      user,
      elements,
      stripe
    } = params;
    let { metadata } = params;
    const { error: submitError } = elements.submit();
    if (!submitError?.message) {
      metadata = {
        ...metadata,
        ...{
          organization: client.clientName,
          client_id: client.clientShortName
        }
      };

      const paymentIntentURL = GET_PAYMENT_INTENT_URL_STRIPE;
      const paymentIntent = yield call(() =>
        Axios.core.post(paymentIntentURL, {
          amount: productSummary.cost,
          clientId: client.id,
          currency: productSummary.currency.toLowerCase(),
          account: productSummary.stripeMerchantId,
          metadata
        })
      );

      const { error } = yield stripe.confirmPayment({
        elements,
        clientSecret: paymentIntent.data.client_secret,
        confirmParams: {
          return_url: `${window.location.origin}/success`,
          payment_method_data: {
            billing_details: {
              email: user.username
            }
          }
        },
        redirect: "if_required"
      });
      if (!error) {
        toastr.clean();
        yield put(submitPlayerPurchaseStripeDone());
        history.push(
          `/${shortName}/${EVENTS}/${eventId}/${PURCHASE}${location.search}`
        );
      } else {
        loadingState.clearState();
        yield put(submitPlayerPurchaseStripeError(error.message));
        showErrorSnackbar(SOMETHING_WENT_WRONG_MESSAGE, {
          removeOnHover: false
        });
      }
    } else {
      loadingState.clearState();
      yield put(submitPlayerPurchaseStripeError(submitError?.message));
      showErrorSnackbar(SOMETHING_WENT_WRONG_MESSAGE, {
        removeOnHover: false
      });
    }
  } catch (e) {
    loadingState.clearState();
    yield put(submitPlayerPurchaseStripeError(e.message));
    showErrorSnackbar(SOMETHING_WENT_WRONG_MESSAGE, {
      removeOnHover: false
    });
  }
}

export default submitPurchaseStripe;
